export function addCurrent(hirerconfig) {
    return {
        type: 'ADD_CURRENT_HIRERCONFIG',
        hirerconfig,
    }
}